module.exports = __webpack_public_path__ + "app/modals/delete-device-group-modal.view.html";